import { useAuthStore } from '@/features/auth/auth-store';
import {
  PriceSchema,
  Provisioning,
  ProvisioningSchema,
} from '@/features/provisioning/provisioning.type';
import { apiWrapper } from '@/shared/use-api';
import { getConfig } from '@/utils/config';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getProvisioningQueryOptions = ({
  accessToken,
}: {
  accessToken: string | undefined;
}) => {
  const baseUrl =
    getConfig().featureFlags.provisionOrganizationApiBaseUrl;

  return queryOptions({
    queryKey: ['provisioning'],
    queryFn: () => {
      if (
        import.meta.env.DEV &&
        import.meta.env.VITE_FAKE_PROVISIONING_RESPONSE === 'true'
      ) {
        // return Promise.resolve(undefined);

        const provisioning: Provisioning = {
          organisationName: 'Test Organisation',
          serviceTier: 'BASIC',
          status: 'CHECKOUT_REQUIRED',
          userSeatsUsed: 1,
          userSeats: 10,
        };

        return Promise.resolve(provisioning);
      }

      return apiWrapper({
        baseUrl,
        endpoint: '/',
        method: 'GET',
        accessToken,
        responseSchema: ProvisioningSchema,
        isPaginated: false,
      });
    },
    enabled: !!baseUrl,
    refetchInterval: (query) => {
      const data = query.state.data;
      const status = data?.status;

      if (status === 'PROVISIONING') {
        return 3000;
      }

      return false;
    },
  });
};

export const useProvisioningQuery = () => {
  const { accessToken } = useAuthStore();

  return useQuery(getProvisioningQueryOptions({ accessToken }));
};

export const usePricesQuery = () => {
  const { accessToken } = useAuthStore();
  const baseUrl =
    getConfig().featureFlags.provisionOrganizationApiBaseUrl;

  return useQuery({
    queryKey: ['prices'],
    queryFn: () => {
      return apiWrapper({
        baseUrl,
        endpoint: '/prices',
        method: 'GET',
        accessToken,
        responseSchema: PriceSchema,
        isPaginated: false,
      });
    },
    enabled: !!baseUrl,
  });
};
